import React from 'react';
import { Head } from '@inertiajs/react';
import TagList from '@/components/admin/blog/TagList';

interface Tag {
  id: number;
  name: string;
  slug: string;
  post_count: number;
  created_at: string;
  updated_at: string;
}

interface Props {
  tags: Tag[];
}

const Index: React.FC<Props> = ({ tags }) => {
  return (
    <>
      <Head title="Blog Tags" />
      <TagList tags={tags} canCreate={true} canEdit={true} canDelete={false} />
    </>
  );
};

export default Index;
